import { copyInputTypes } from '@/configuration/pages/ConfigurationPage/ReturnsPortalConfiguration/ReturnsPortalCopiesPage/constants'

import * as Styles from './styles'

const CopyDefaultText = ({ copy, lang, merchantInfo }) => (
  <Styles.DefaultText>
    {copy?.copyType === copyInputTypes.text && <p>{`"${copy?.placeholder(lang)}"`}</p>}
    {copy?.copyType === copyInputTypes.richText && <p>{`"${copy?.textareaPlaceholder(lang)}"`}</p>}
    {copy?.copyType === copyInputTypes.titleAndTextArea && (
      <>
        {!copy?.hideInput && <p>{`"${copy?.placeholder(lang)}"`}</p>}
        <p>{`"${copy?.textareaPlaceholder(lang, merchantInfo)}"`}</p>
      </>
    )}
  </Styles.DefaultText>
)

export default CopyDefaultText
